import React from 'react';
import { array } from 'prop-types';
import css from './SeoDiscovery.module.css';
import { sanitizeDisplayCopy } from './seoCopyDisplay';

const SeoFaqSection = props => {
  const { blocks } = props;
  const faqBlock = (blocks || []).find(b => b.blockType === 'faq');
  const faqs = faqBlock?.content?.faqs || [];
  if (!faqs.length) {
    return null;
  }
  return (
    <section className={css.section}>
      <h2>Frequently Asked Questions</h2>
      <dl className={css.faq}>
        {faqs.map((f, i) => (
          <React.Fragment key={i}>
            <dt>{sanitizeDisplayCopy(f.question)}</dt>
            <dd>{sanitizeDisplayCopy(f.answer)}</dd>
          </React.Fragment>
        ))}
      </dl>
    </section>
  );
};

SeoFaqSection.propTypes = {
  blocks: array,
};

export default SeoFaqSection;
